<div class="card">
    <div class="card-body">
        <div class="top-span">
            <span class="label label-primary">Question {{index}}</span>
        </div>

        <span class="q-title"><strong>{{index}}.</strong> {{question.text}}</span>
        <div class="divider-text" *ngIf="question.answers.length > 0;">
            <span>Answer</span>
        </div>
        <div class="qcm">
            <div class="row" *ngFor="let answer of question.answers">
                <a *ngIf="!showAnswer && !hideAction" (click)="onChooseAnswer(answer)" href="javascript:;">
                    <i [ngClass]="setClasses(answer)"></i> {{answer.text}} 
                </a>
                <a *ngIf="showAnswer || hideAction" class="no-pointer" href="javascript:;">
                    <i [ngClass]="setClasses(answer)"></i> {{answer.text}} <i *ngIf="checkYourAnswer(answer.id)" class="bx bx-x-circle"></i>
                </a>
            </div>
        </div>

    </div>
</div>


<div class="d-flex flex-row-reverse" *ngIf="!hideAction">
    <div>
        <button [ngClass]="setButtonNextClasses()"  *ngIf="index === maxIndex;else elseBlock" (click)="onSubmit()" type="button" class="btn">
            Submit
        </button>
        <ng-template #elseBlock>
            <button [ngClass]="setButtonNextClasses()"  (click)="onNext()" type="button">
                Next
            </button>
        </ng-template>
    </div>
    <div><button [ngClass]="setButtonPreviousClasses()" (click)="onPrevious()" type="button">Previous</button></div>
</div>